import { Info } from 'react-feather'
import { UncontrolledTooltip } from 'reactstrap'
import { getHoursDescriptions } from './metricDescriptions'

const colors = { green: '#d1fae5', yellow: '#fef3c7', red: '#fee2e2' }

const sections = [
  {
    title: 'Kelengkapan Awal Pekerja',
    indicators: [
      { name: 'Kontrak Kerja', key: 'contract', statuses: [['green', '100%: kontrak tercatat'], ['red', '0%: kontrak belum tercatat']] },
      { name: 'Asuransi dan Jaminan Sosial', key: 'insurance', statuses: [['green', '100%: perlindungan tercatat'], ['red', '0%: perlindungan belum tercatat']] },
      { name: 'Usia Minimum', key: 'minimumAge', statuses: [['green', '100%: memenuhi batas usia'], ['red', '0%: belum memenuhi atau usia tidak diketahui']] },
      { name: 'Nilai Kelengkapan Awal', key: 'onboardingScore', statuses: [['green', '80% ke atas'], ['yellow', '60% sampai kurang dari 80%'], ['red', 'Di bawah 60%']] },
    ],
  },
  {
    title: 'Jam Kerja, Upah, dan Produktivitas',
    indicators: [
      { name: 'Jam Kerja', key: 'workHours', statuses: [['green', 'Sampai dengan 100% dari standar'], ['yellow', 'Lebih dari 100% sampai 120%'], ['red', 'Lebih dari 120%']] },
      { name: 'Upah Minimum', key: 'wageAboveMinimum', statuses: [['green', '80% ke atas'], ['yellow', '60% sampai kurang dari 80%'], ['red', 'Di bawah 60%']] },
      { name: 'Catatan Pembayaran Upah', key: 'paymentLogs', statuses: [['green', '100%: catatan tersedia'], ['red', '0%: catatan belum tersedia']] },
      { name: 'Hasil Kerja', key: 'productivity', statuses: [['green', '80% ke atas'], ['yellow', '60% sampai kurang dari 80%'], ['red', 'Di bawah 60%']] },
      { name: 'Nilai Upah dan Produktivitas', key: 'wageScore', statuses: [['green', '80% ke atas'], ['yellow', '60% sampai kurang dari 80%'], ['red', 'Di bawah 60%']] },
    ],
  },
]

const ComplianceLegend = ({ isCoordinator, standardHours }) => (
  <div className="mt-5 pt-4" style={{ borderTop: '2px solid #e0e0e0' }}>
    <h5 className="mb-4 fw-bold">Arti Warna</h5>
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 450px), 1fr))', gap: '1.5rem' }}>
      {sections.map((section) => (
        <div key={section.title} style={{ backgroundColor: '#fff', borderRadius: 8, border: '1px solid #dee2e6', overflow: 'hidden' }}>
          <div className="fw-semibold p-3 bg-light border-bottom">{section.title}</div>
          <table className="w-100 small">
            <thead><tr><th className="p-3 text-start">Penilaian</th><th className="p-3 text-start">Arti Warna</th></tr></thead>
            <tbody>
              {section.indicators.map((indicator) => indicator.statuses.map(([color, status], index) => (
                <tr key={`${indicator.key}-${color}`}>
                  {index === 0 && <td rowSpan={indicator.statuses.length} className="p-3 align-middle border-top" style={{ width: '40%' }}>
                    <span className="d-inline-flex align-items-center gap-1">
                      {indicator.name}{(indicator.key === 'workHours' || indicator.key === 'productivity') && isCoordinator && <span className="text-danger fw-bold">*</span>}
                      <span id={`legend-${indicator.key}`}><Info size={13} className="text-muted cursor-pointer" /></span>
                      <UncontrolledTooltip placement="top" target={`legend-${indicator.key}`}>{getHoursDescriptions(standardHours)[indicator.key]}</UncontrolledTooltip>
                    </span>
                  </td>}
                  <td className="p-3 border-top"><span className="d-inline-block me-2 align-middle" style={{ width: 20, height: 20, backgroundColor: colors[color], border: '1px solid #d1d5db', borderRadius: 4 }} />{status}</td>
                </tr>
              )))}
            </tbody>
          </table>
        </div>
      ))}
    </div>
    {isCoordinator && <div className="mt-3 p-3 rounded bg-light border text-secondary small"><span className="text-danger fw-bold me-1">*</span>Jam Kerja dan Hasil Kerja pada grup ini hanya sebagai indikasi. Jam Kerja tidak digunakan dalam perhitungan sebenarnya, dan tidak ada jam kerja aktual yang dicatat untuk Hasil Kerja (digunakan sebagai acuan).</div>}
  </div>
)

export default ComplianceLegend
